import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { cn } from "../lib/utils";
import * as React from "react";
import { useMemo } from "react";
const ScrollArea = React.forwardRef(({ className, children, hideScrollBar = false, orientation = "vertical", scrollContainment = "default", scrollBarClassName, viewportClassName, viewportRef, ...props }, ref) => {
    const localViewportRef = React.useRef(null);
    const hasCustomScrollBar = useMemo(() => React.Children.toArray(children).some((child) => React.isValidElement(child) &&
        child.type.displayName ===
            ScrollBar.displayName), [children]);
    const shouldHideDefaultScrollBar = hideScrollBar || hasCustomScrollBar;
    return (React.createElement(ScrollAreaPrimitive.Root, { ref: ref, className: cn("relative z-20", scrollContainment === "horizontal"
            ? "overflow-x-auto overflow-y-visible"
            : "overflow-hidden", className), ...props },
        React.createElement(ScrollAreaPrimitive.Viewport, { ref: viewportRef || localViewportRef, className: cn("scrollarea-viewport h-full w-full rounded-[inherit]", viewportClassName) }, children),
        React.createElement(ScrollBar, { orientation: orientation, className: cn(scrollBarClassName, shouldHideDefaultScrollBar && "hidden") }),
        React.createElement(ScrollAreaPrimitive.Corner, null)));
});
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
const scrollBarSizes = {
    compact: {
        bar: {
            vertical: "w-5",
            horizontal: "h-5",
        },
        padding: {
            vertical: "pr-1 pl-2.5 py-2 hover:pl-2",
            horizontal: "pb-1 pt-2.5 px-2",
        },
        thumb: cn("bg-muted-foreground/40", "hover:bg-muted-foreground/70"),
    },
    classic: {
        bar: {
            vertical: "w-5",
            horizontal: "h-5",
        },
        padding: {
            vertical: "pl-2 pr-1 py-1",
            horizontal: "py-0.5 px-1",
        },
        thumb: cn("bg-muted-foreground/70", "hover:bg-muted-foreground/80"),
    },
    minimal: {
        bar: {
            vertical: "w-3",
            horizontal: "h-3",
        },
        padding: {
            vertical: "pr-px pl-1.5 py-px",
            horizontal: "pb-px pt-1.5 px-px",
        },
        thumb: cn("bg-muted-foreground/20", "hover:bg-muted-foreground/50"),
    },
};
const ScrollBar = React.forwardRef(({ className, orientation = "vertical", size = "compact", ...props }, ref) => {
    const sizeConfig = scrollBarSizes[size];
    return (React.createElement(ScrollAreaPrimitive.ScrollAreaScrollbar, { ref: ref, orientation: orientation, className: cn("flex touch-none select-none hover:cursor-pointer", orientation === "vertical" && [
            "h-full border-l border-l-transparent",
            sizeConfig.bar.vertical,
            sizeConfig.padding.vertical,
        ], orientation === "horizontal" && [
            "flex-col border-t border-t-transparent",
            sizeConfig.bar.horizontal,
            sizeConfig.padding.horizontal,
        ], className), ...props },
        React.createElement(ScrollAreaPrimitive.ScrollAreaThumb, { className: cn("relative flex-1 rounded-full transition-colors duration-200", sizeConfig.thumb) })));
});
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
export { ScrollArea, ScrollBar };
//# sourceMappingURL=ScrollArea.js.map